function parseErrorObject(obj) {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => parseErrorObject(item));
  }

  if (typeof obj === 'object') {
    const parsed = {};
    for (const [key, value] of Object.entries(obj)) {
      if (typeof value === 'string') {
        parsed[key] = { message: value };
      } else {
        parsed[key] = parseErrorObject(value);
      }
    }
    return parsed;
  }

  return obj;
}

module.exports = parseErrorObject;
